import { DafAuthError } from '../types';

export const dafErrorMap = {
    '401': DafAuthError.UNAUTHENTICATED,
    '403': DafAuthError.UNAUTHORISED,
    '500': DafAuthError.INTERNAL_SERVER_ERROR,
    '429': DafAuthError.TPS_LIMIT_REACHED
};
